import React from "react";
import PageShell from "../components/layout/PageShell";
import CinematicHero, { HeroOverlay } from "../components/layout/CinematicHero";
import Container from "../components/primitives/Container";
import Section from "../components/primitives/Section";
import Reveal from "../components/primitives/Reveal";
import SeoHead from "../components/seo/SeoHead";
import { IMAGES } from "../content/images";
import { CAREERS } from "../content/site";

const Careers = () => {
  const { hero, paragraph, intro, contactEmail } = CAREERS;
  return (
    <PageShell>
      <SeoHead
        title="Careers"
        description="Senior appointments at Quantum are made through direct partnership and long-standing professional relationships. Expressions of interest are read personally."
        path="/careers"
        ogImage={IMAGES.careers_hero}
        noIndex
      />
      <CinematicHero
        image={IMAGES.careers_hero}
        imageAlt="A quiet institutional corridor at first light."
        eager
        data-testid="careers-hero"
      >
        <HeroOverlay
          eyebrow={hero.eyebrow}
          title={hero.headline}
          statement="The firm expands deliberately."
          size="short"
        />
      </CinematicHero>

      <Section tone="light" className="py-16 md:py-20 lg:py-24" data-testid="careers-body">
        <Container>
          <Reveal className="max-w-2xl">
            <p className="font-sans text-[16px] sm:text-[17px] leading-[1.8] text-navy/80">
              {paragraph}
            </p>
            <p className="mt-10 font-serif italic text-navy/60" style={{ fontSize: "17px" }}>
              {intro}
            </p>
            <a
              href={`mailto:${contactEmail}`}
              data-testid="careers-email"
              className="group mt-8 inline-block font-serif text-navy"
              style={{ fontSize: "clamp(22px, 2.2vw, 32px)" }}
            >
              <span className="relative">
                {contactEmail}
                <span
                  aria-hidden="true"
                  className="absolute left-0 right-0 -bottom-1 h-px bg-gold scale-x-0 origin-left transition-transform duration-300 ease-out group-hover:scale-x-100"
                />
              </span>
            </a>
            <span aria-hidden="true" className="mt-10 block h-px w-8 bg-gold" />
          </Reveal>
        </Container>
      </Section>
    </PageShell>
  );
};

export default Careers;
